module.exports = __webpack_public_path__ + "img/button-down.3b538096.svg";